<div class="container-fluid py-4">
  <!-- Header -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h3 class="mb-1">
                <i class="fas fa-shield-alt text-primary"></i>
                Simulador de Domiciliación de Seguros
              </h3>
              <p class="text-muted mb-0">
                Simula el flujo completo de validación de domiciliación para compra de seguros
              </p>
            </div>
            <div class="d-flex align-items-center">
              <select 
                class="form-control form-control-sm mr-2" 
                style="width: 200px;"
                [(ngModel)]="productType"
                [disabled]="currentStep !== 'search'">
                <option value="SEGUROS_MERCANTIL">Seguros Mercantil</option>
                <option value="CREDIT">Crédito</option>
                <option value="RECARGAS">Recargas</option>
              </select>
              <span class="badge {{ getStatusBadge().class }} badge-lg">
                {{ getStatusBadge().text }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Paso 1: Búsqueda de Cliente -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-header bg-primary text-white">
          <h5 class="mb-0">
            <i class="fas fa-search"></i> Paso 1: Buscar Cliente
          </h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="customerNationality">
                  <strong>Nacionalidad:</strong>
                </label>
                <select 
                  id="customerNationality"
                  class="form-control" 
                  [(ngModel)]="customerNationality"
                  [disabled]="isLoadingCustomer || currentStep !== 'search'">
                  <option *ngFor="let nat of nationalities" [value]="nat.code">
                    {{ nat.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="customerIdentification">
                  <strong>Número de Cédula:</strong>
                </label>
                <input 
                  type="text" 
                  id="customerIdentification"
                  class="form-control" 
                  [(ngModel)]="customerIdentification"
                  placeholder="Ej: 12345678"
                  [disabled]="isLoadingCustomer || currentStep !== 'search'"
                  (keyup.enter)="searchCustomer()">
                <small class="form-text text-muted">
                  Solo números, sin guiones ni puntos
                </small>
              </div>
            </div>
            <div class="col-md-4 d-flex align-items-end">
              <button 
                class="btn btn-primary btn-block"
                (click)="searchCustomer()"
                [disabled]="isLoadingCustomer || !customerIdentification || currentStep !== 'search'">
                <i class="fas fa-search"></i>
                {{ isLoadingCustomer ? 'Buscando...' : 'Buscar Cliente' }}
              </button>
            </div>
          </div>

          <!-- Datos del cliente encontrado -->
          <div *ngIf="customerData" class="mt-4 p-3 bg-light border rounded">
            <h6 class="text-success mb-3">
              <i class="fas fa-check-circle"></i> Cliente Encontrado
            </h6>
            <div class="row">
              <div class="col-md-4">
                <p class="mb-1"><strong>Nombre:</strong></p>
                <p>{{ customerData.name }} {{ customerData.last_name }}</p>
              </div>
              <div class="col-md-4">
                <p class="mb-1"><strong>Cédula:</strong></p>
                <p>{{ customerData.identification }}</p>
              </div>
              <div class="col-md-4">
                <p class="mb-1"><strong>Code:</strong></p>
                <p><code>{{ customerData.code }}</code></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Paso 2: Simular Compra -->
  <div class="row mb-4" *ngIf="customerData">
    <div class="col-12">
      <div class="card shadow-sm border-success">
        <div class="card-header bg-success text-white">
          <h5 class="mb-0">
            <i class="fas fa-shopping-cart"></i> Paso 2: Simular Compra de Seguro
          </h5>
        </div>
        <div class="card-body">
          <p class="mb-3">
            Al hacer clic en el botón, se validará si el cliente tiene domiciliación activa para 
            <strong>{{ getProductName() }}</strong>
          </p>
          
          <button 
            class="btn btn-success btn-lg btn-block"
            (click)="simulateInsurancePurchase()"
            [disabled]="isLoadingValidation || !customerData">
            <i class="fas fa-shield-alt"></i>
            {{ isLoadingValidation ? 'Validando Domiciliación...' : 'Realizar Compra de Seguro' }}
          </button>

          <div *ngIf="isLoadingValidation" class="mt-3 text-center">
            <div class="spinner-border text-success" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
            <p class="mt-2 text-muted">Consultando estado de domiciliación...</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Resultados Inline -->
  <div class="row mb-4" *ngIf="validationResult">
    <div class="col-12">
      <!-- CASO 1: Domiciliado -->
      <div *ngIf="validationResult.domiciliated === true" class="alert alert-success">
        <h5 class="alert-heading">
          <i class="fas fa-check-circle"></i> CASO 1: Cliente Domiciliado
        </h5>
        <p>El cliente ya tiene domiciliación activa para {{ getProductName() }}</p>
        <hr>
        <p class="mb-0">
          <strong>Acción:</strong> Puede proceder con la compra sin acciones adicionales
        </p>
      </div>

      <!-- CASO 2A-BIS: Afiliación Pendiente -->
      <div *ngIf="validationResult.has_payment_method_registered === true && 
                  validationResult.has_terms_accepted === true && 
                  validationResult.afiliation_status === 'PENDING'" 
           class="alert alert-warning">
        <h5 class="alert-heading">
          <i class="fas fa-clock"></i> CASO 2A-BIS: Afiliación en Proceso
        </h5>
        <p>El cliente tiene método de pago y T&C aceptados, pero la afiliación está pendiente de aprobación bancaria</p>
        <div *ngIf="validationResult.afiliation_details && validationResult.afiliation_details.length > 0">
          <p><strong>Afiliaciones pendientes:</strong></p>
          <ul>
            <li *ngFor="let aff of validationResult.afiliation_details">
              {{ aff.bank }} - Estado: {{ aff.status }} ({{ aff.created_at | date:'short' }})
            </li>
          </ul>
        </div>
        <hr>
        <p class="mb-0">
          <strong>Acción:</strong> Esperar aprobación del banco. El cliente puede proceder una vez aprobada la afiliación.
        </p>
      </div>

      <!-- CASO 2A: T&C Pendientes -->
      <div *ngIf="validationResult.has_payment_method_registered === true && validationResult.has_terms_accepted === false" 
           class="alert alert-warning">
        <h5 class="alert-heading">
          <i class="fas fa-file-contract"></i> CASO 2A: Términos y Condiciones Pendientes
        </h5>
        <p>El cliente tiene método de pago registrado pero debe aceptar T&C</p>
        <hr>
        <p class="mb-0">
          <strong>Acción:</strong> Se mostrarán los T&C para aceptación
        </p>
      </div>

      <!-- CASO 2B: Cuentas Copiables -->
      <div *ngIf="validationResult.other_domiciliations && validationResult.other_domiciliations.length > 0" 
           class="alert alert-info">
        <h5 class="alert-heading">
          <i class="fas fa-copy"></i> CASO 2B: Cuentas Copiables Disponibles
        </h5>
        <p>El cliente tiene cuentas domiciliadas en otros productos:</p>
        <ul>
          <li *ngFor="let acc of validationResult.other_domiciliations">
            {{ acc.bank }} - {{ acc.account_number }} ({{ acc.product_type }})
          </li>
        </ul>
        <hr>
        <p class="mb-0">
          <strong>Acción:</strong> Cliente puede copiar una cuenta existente y aceptar T&C
        </p>
      </div>

      <!-- CASO 3: Sin Métodos de Pago -->
      <div *ngIf="validationResult.has_payment_method_registered === false" 
           class="alert alert-danger">
        <h5 class="alert-heading">
          <i class="fas fa-exclamation-triangle"></i> CASO 3: Sin Métodos de Pago
        </h5>
        <p>El cliente no tiene métodos de pago registrados</p>
        <div *ngIf="validationResult.compatible_banks && validationResult.compatible_banks.length > 0">
          <p><strong>Bancos compatibles:</strong></p>
          <ul>
            <li *ngFor="let bank of validationResult.compatible_banks">
              {{ bank.name }}
            </li>
          </ul>
        </div>
        <hr>
        <p class="mb-0">
          <strong>Acción:</strong> Redirigir al módulo de registro de métodos de pago
        </p>
      </div>

      <!-- JSON Completo (Debug) -->
      <div class="mt-3">
        <button 
          class="btn btn-sm btn-outline-secondary" 
          type="button" 
          data-toggle="collapse" 
          data-target="#jsonResponse">
          <i class="fas fa-code"></i> Ver JSON Completo
        </button>
        <div class="collapse mt-2" id="jsonResponse">
          <pre class="bg-dark text-light p-3 rounded">{{ validationResult | json }}</pre>
        </div>
      </div>
    </div>
  </div>

  <!-- Botones de Acción -->
  <div class="row" *ngIf="customerData">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-body">
          <div class="d-flex justify-content-between">
            <button 
              class="btn btn-secondary"
              (click)="reset()">
              <i class="fas fa-redo"></i> Reiniciar Simulador
            </button>
            
            <div>
              <button 
                class="btn btn-outline-primary mr-2"
                *ngIf="currentStep === 'register_payment'"
                (click)="redirectToPaymentMethodRegistration()">
                <i class="fas fa-credit-card"></i> Ir a Registro de Métodos de Pago
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Leyenda de Casos -->
  <div class="row mt-4">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-header bg-light">
          <h5 class="mb-0">
            <i class="fas fa-book"></i> Leyenda de Casos
          </h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="border-left border-success pl-3">
                <h6 class="text-success">
                  <i class="fas fa-check-circle"></i> CASO 1: Cliente Domiciliado
                </h6>
                <p class="small mb-0">
                  El cliente ya tiene domiciliación activa. Puede proceder directamente con la compra.
                </p>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div class="border-left border-warning pl-3">
                <h6 class="text-warning">
                  <i class="fas fa-clock"></i> CASO 2A-BIS: Afiliación Pendiente
                </h6>
                <p class="small mb-0">
                  Tiene método de pago y T&C aceptados, pero la afiliación está en proceso de aprobación bancaria.
                </p>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div class="border-left border-warning pl-3">
                <h6 class="text-warning">
                  <i class="fas fa-file-contract"></i> CASO 2A: T&C Pendientes
                </h6>
                <p class="small mb-0">
                  Tiene método de pago pero debe aceptar términos y condiciones.
                </p>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div class="border-left border-info pl-3">
                <h6 class="text-info">
                  <i class="fas fa-copy"></i> CASO 2B: Cuentas Copiables
                </h6>
                <p class="small mb-0">
                  Puede copiar una cuenta de otro producto y aceptar T&C.
                </p>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div class="border-left border-danger pl-3">
                <h6 class="text-danger">
                  <i class="fas fa-exclamation-triangle"></i> CASO 3: Sin Métodos de Pago
                </h6>
                <p class="small mb-0">
                  Debe registrar un método de pago domiciliable.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
